function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurso191(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Capa 2",
    viewBox: "0 0 84.72 54.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M71.99 13.69a53.33 53.33 0 0 0 12.08-7.35c.73-.56.87-1.6.32-2.33-.08-.1-.15-.18-.23-.26a15.362 15.362 0 0 0-16.37-2.39l-20.58 9.29c-.1.04-.22.05-.34.01L26.39 3.79c-3.09-.66-6.31-.17-9.07 1.38-.38.2-.52.66-.32 1.04.06.11.14.21.25.28l15.52 9.87c.22.13.27.42.13.64-.05.07-.12.13-.2.16l-17.35 7.83c-.47.21-1.02.17-1.45-.1L2.96 18.01c-.9-.57-2.09-.29-2.65.61-.35.56-.39 1.26-.11 1.85l6.62 13.84a3.702 3.702 0 0 0 3.23 2.12c7.04.23 14.04-1.15 20.47-4.05l12.06-5.44c.23-.1.5 0 .61.24.03.08.04.17.03.26l-4.64 26.63c-.08.42.2.82.62.89.12.02.25.01.37-.02a12.21 12.21 0 0 0 6.47-5.03l14.04-30.74c.04-.1.13-.19.22-.23L72 13.69",
    "data-name": "Capa 1",
    style: {
      fill: "#5c4c34"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso191);
export default __webpack_public_path__ + "static/media/Recurso-19-1.845bdf10eca250c85c273ccd43f601b7.svg";
export { ForwardRef as ReactComponent };